// adapted from http://stackoverflow.com/a/5831191/1614967
const youtubeRegexp =
  /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gi;
const timeRegexp = /t=(\d+)[ms]?(\d+)?s?/;

function contains(str, substr) {
  return str.indexOf(substr) > -1;
}

export const getIdFromURL = (url) => {
  if (!url || typeof url !== "string") {
    return "";
  }

  let id = url.replace(youtubeRegexp, "$1");

  // If regex didn't match, it returns the original URL
  // Check if we got the original URL back (regex didn't match)
  if (id === url || id.includes("http")) {
    return "";
  }

  if (contains(id, ";")) {
    const pieces = id.split(";");

    if (contains(pieces[1], "%")) {
      // links like this:
      // "http://www.youtube.com/attribution_link?a=pxa6goHqzaA&amp;u=%2Fwatch%3Fv%3DdPdgx30w9sU%26feature%3Dshare"
      // have the real query string URI encoded behind a ';'.
      // at this point, `id is 'pxa6goHqzaA;u=%2Fwatch%3Fv%3DdPdgx30w9sU%26feature%3Dshare'
      const uriComponent = decodeURIComponent(pieces[1]);
      id = ("http://youtube.com" + uriComponent).replace(youtubeRegexp, "$1");

      // Validate the extracted ID after decoding
      if (id === ("http://youtube.com" + uriComponent) || id.includes("http")) {
        return "";
      }
    } else {
      // https://www.youtube.com/watch?v=VbNF9X1waSc&amp;feature=youtu.be
      // `id` looks like 'VbNF9X1waSc;feature=youtu.be' currently.
      // strip the ';feature=youtu.be'
      id = pieces[0];
    }
  } else if (contains(id, "#")) {
    // id might look like '93LvTKF_jW0#t=1'
    // and we want '93LvTKF_jW0'
    id = id.split("#")[0];
  }

  // Validate that we have a valid 11-character YouTube video ID
  // YouTube video IDs are always exactly 11 characters
  if (id && id.length === 11 && !id.includes("http") && !id.includes("://")) {
    return id;
  }

  return "";
};
